import { fg } from '@atlassian/jira-feature-gating';

const JscMergedColumnRelayProvider = {
	get(): boolean {
		return fg('jira_list_merged_column_gate');
	},
};

export default JscMergedColumnRelayProvider;
